import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CopyRegular from './copy-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CopyRegular {...validProps} />;
}
SvgComponent.iconName = 'copyRegular';

export const CopyRegularIcon = svgIconWrapper(SvgComponent);
